// Help overlay listing all the patterns. Triggered from a "?" button visible
// on every screen. Click outside or hit ✕ to dismiss.
const PATTERNS = [
    { label: 'Double', glyphs: '7♠ 7♣', rule: 'Two cards of the same rank, adjacent.', earn: '+2', steal: '—' },
    { label: 'Triple', glyphs: '7♠ 7♥ 7♣', rule: 'Three cards of the same rank, adjacent.', earn: '+4', steal: '—' },
    { label: 'Sandwich', glyphs: '4♥ K♦ 4♣', rule: 'X – Y – X. Same rank with one different-rank card between them.', earn: '—', steal: 'Steal 3' },
    { label: 'Marriage', glyphs: 'K♠ Q♥', rule: 'A King and a Queen adjacent (any suits).', earn: '+5', steal: '—' },
    { label: 'Run', glyphs: '5♣ 6♥ 7♦', rule: 'Three or more consecutive ranks, ascending or descending. Aces flex as 1 or 14.', earn: '+1 per card in run', steal: '—' },
    { label: 'Suit Chain', glyphs: '2♠ 9♠ J♠', rule: 'Three or more cards of the same suit in a row.', earn: '—', steal: 'Steal 2' },
    { label: 'Flush', glyphs: '2♥ 7♥ 9♥ J♥ K♥', rule: 'Five or more cards of the same suit anywhere on the Plank (order doesn\'t matter).', earn: '—', steal: 'Steal 4' },
    { label: 'Straight Flush', glyphs: '5♠ 6♠ 7♠', rule: 'A Run that\'s also entirely the same suit. Layered on top of the Run + Suit Chain that already fire.', earn: '+3 bonus', steal: '+3 bonus' },
    { label: 'Parity Squad', glyphs: '2♠ 4♥ 6♣ 8♦ 10♠', rule: 'Five 2–10 cards (or Aces) all even or all odd. Face cards (J/Q/K) do NOT count — they\'re already powerful via Royalty/Marriage. Aces are odd.', earn: '+3', steal: 'Steal 1' },
    { label: 'Royalty Stack', glyphs: 'J♦ Q♥ K♠', rule: 'Three face cards (J/Q/K) in a row.', earn: '—', steal: '—', bonus: '🌊 Opponent loses 2 cards overboard next turn (gone for the match).' },
    { label: 'Mutiny', glyphs: '7♥ 7♦ 7♠ 7♣', rule: 'Four of a kind anywhere on the Plank.', earn: '—', steal: 'Steal 8' },
];
const TIPS = [
    {
        title: 'How scoring works',
        body: 'Each turn you play 1–5 cards from your hand onto the Plank. The game scans them for every pattern that matches — multiple patterns can fire from one play (a Sandwich K-Q-K also contains a Marriage). Your Crew can boost specific patterns or react to your opponent\'s plays.',
    },
    {
        title: 'How you win',
        body: 'You start at 25 doubloons. Hit 0 and your ship sinks (you lose). Hit 50 and you\'ve plundered enough (you win). Buying Crew or Edicts costs doubloons — your purse is your hull, so spend carefully.',
    },
    {
        title: 'Solo Run (PvE)',
        body: 'Start with the hull your ship gives you (default Brigantine = 30). Five ante checkpoints: <strong>38 → 65 → 95 → 130 → 175</strong>. You play <strong>all 4 hands</strong> per ante (no early lock-in), then the threshold is checked. Hit it → visit the Port and continue. Miss it → the run ends. After clearing ante 5, <strong>endless mode</strong> kicks in and every subsequent ante doubles the threshold (350, 700, 1400, …). In PvE, "steal" effects pay from the Treasury (no opponent), so Sandwiches and Mutinies still earn you hull. Captain + Ship + Voyage picks at run start commit you to a build lane.',
    },
    {
        title: 'The Port',
        body: 'After both players take a turn, the Port appears. The captain with more doubloons picks first. Each purchase reduces your doubloons (= your hull), so every shop choice is a tradeoff.',
    },
    {
        title: 'Pattern overlap',
        body: 'Patterns are detected greedily and overlap on purpose. K-Q-K fires both Sandwich AND Marriage — that\'s a 5+3=8 swing turn. Stack your hand to chain patterns together.',
    },
    {
        title: 'Toss & Redraw',
        body: 'You get <strong>4 single-card tosses per turn</strong>. Drag a card from your hand to the 🗑 bin and it goes to your discard pile while a fresh card is drawn into its place. One card at a time, so you can react to each draw. Tossed cards are <strong>not</strong> overboard — they cycle back when your draw pile empties. Crew that raise the cap: <strong>Bilge Pump</strong> (+1 per copy), <strong>Coxswain</strong> (+2 per copy).',
    },
    {
        title: 'Wild Cards',
        body: 'Two flavors. <strong>Rank-Wild</strong> (the Joker) — has a real suit, but counts as any rank for pattern detection. Useful for filling Run gaps, completing Sandwiches, or padding Mutiny totals. <strong>Suit-Wild</strong> — has a real rank, but counts as any suit. Useful for completing Suit Chains. Both are bought at the Port as deck-mods. Wilds need at least one concrete card nearby to trigger a pattern (a plank of just wilds doesn\'t auto-fire everything).',
    },
    {
        title: 'Two kinds of card loss: Discard vs Overboard',
        body: 'There are two distinct piles. <strong>Discard pile</strong> holds cards you played this turn or voluntarily tossed (Toss & Redraw). When your draw pile runs out, the discard pile gets shuffled back in — nothing is lost. <strong>Overboard 🌊</strong> is the punishment pile: cards forced out by Royalty Stack, Bilge Rat, or Plague Rat go here, and they\'re <strong>gone for the match</strong>. Random selection from the victim\'s hand, then their hand refills as normal. Your captain panel shows "🌊 N overboard" to track how many cards you\'ve lost forever. The Parley edict cancels pending overboard losses on you.',
    },
];
export function mountHelpButton() {
    if (document.getElementById('help-fab'))
        return;
    const btn = document.createElement('button');
    btn.id = 'help-fab';
    btn.textContent = '?';
    btn.setAttribute('aria-label', 'How to play');
    btn.title = 'How to play';
    btn.addEventListener('click', openHelp);
    document.body.appendChild(btn);
}
function openHelp() {
    if (document.getElementById('help-overlay'))
        return;
    const overlay = document.createElement('div');
    overlay.id = 'help-overlay';
    overlay.className = 'help-overlay';
    overlay.innerHTML = `
    <div class="help-panel" role="dialog" aria-label="How to play">
      <button class="help-close" aria-label="Close">✕</button>
      <h2>How to play <span class="muted">— Plunder</span></h2>

      <div class="help-section">
        <h3>Patterns</h3>
        <table class="patterns-table">
          <thead>
            <tr><th>Pattern</th><th>Example</th><th>Rule</th><th>Earn</th><th>Steal</th></tr>
          </thead>
          <tbody>
            ${PATTERNS.map((p) => `
              <tr>
                <td><strong>${p.label}</strong></td>
                <td><span class="glyph-cell">${p.glyphs}</span></td>
                <td>${p.rule}${p.bonus ? `<br><em class="muted">${p.bonus}</em>` : ''}</td>
                <td>${p.earn}</td>
                <td>${p.steal}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>

      ${TIPS.map((t) => `
        <div class="help-section">
          <h3>${t.title}</h3>
          <p>${t.body}</p>
        </div>
      `).join('')}

      <div class="help-section">
        <h3>Crew &amp; Edicts</h3>
        <p>Crew are persistent power cards bought at the Port. They tweak how patterns score (Powder Monkey: +1 steal on your Sandwiches), react to opponents (Quartermaster: +1 when opponent plays a Double), or modify pattern detection (Navigator: Suit chains need only 2 cards). Edicts are one-shot effects — Cannon Volley steals 4, Repair Crew gives +5, X Marks the Spot doubles your next pattern.</p>
      </div>
    </div>
  `;
    document.body.appendChild(overlay);
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay)
            closeHelp();
    });
    overlay.querySelector('.help-close')?.addEventListener('click', closeHelp);
    document.addEventListener('keydown', escListener);
}
function closeHelp() {
    document.getElementById('help-overlay')?.remove();
    document.removeEventListener('keydown', escListener);
}
function escListener(e) {
    if (e.key === 'Escape')
        closeHelp();
}
